import { useMutation } from '@tanstack/react-query';
import axios from 'axios';

import { queryClient } from '@frontend/sorghum/external-providers';
import {
  PostCommentReplyActiveV2Request,
  PostCommentReplyActiveV2Response,
} from '@frontend/sorghum/interface';
import { COMMENT_REPLY_ACTIVE_V2 } from '../apis';

async function postCommentReplyActiveV2(
  props: PostCommentReplyActiveV2Request,
): Promise<PostCommentReplyActiveV2Response> {
  // 非 20000 或連線失敗都要 reject 走 onError：
  // 之前失敗也 resolve，導致後端發佈失敗（如 2026-07-24 rum 過載 500/504）
  // 前端仍跳「正在運行中」成功視窗，客戶被誤導以為已上線
  return axios.post(COMMENT_REPLY_ACTIVE_V2, props).then((res) => {
    if (res.data?.code !== 20000) return Promise.reject(res.data ?? {});
    return res.data;
  });
}

export function usePostCommentReplyActiveV2() {
  return useMutation({
    mutationKey: ['post-comment-reply-active-v2'],
    mutationFn: (props: PostCommentReplyActiveV2Request) =>
      postCommentReplyActiveV2(props),
    onSuccess: (data, props: PostCommentReplyActiveV2Request) => {
      queryClient.refetchQueries(['get-comment-reply', { uuid: props.id }]);
    },
  });
}

export default usePostCommentReplyActiveV2;
